module.exports = __webpack_public_path__ + "img/G - 04.f6d1b524.png";